// Disclaimer.js
import React from 'react';
import { Button, Divider, Row, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import {PLATFORM_AGREEMENT_DISCLAIMER} from "../configs/disclaimerTextConfig";


const Disclaimer = ({ onAgree, onClose, text=PLATFORM_AGREEMENT_DISCLAIMER}) => {
  return (
      <div>
          <div style={{ maxWidth: 600, margin: 'auto', paddingTop: 100 }}>
              <Typography.Title level={2}>Disclaimer</Typography.Title>
              {onClose && (
                  <div style={{ position: 'absolute', right: 10, top: 10 }}>
                    <Button icon={<CloseOutlined />} onClick={onClose} type="link" />
                  </div>
                )}
                <div
                    style={{
                      overflowY: 'auto',
                      margin: '20px 0',
                      borderRadius: '4px',
                      fontWeight: '400',
                      height: 500, // Adjust the height as necessary
                      fontFamily: "DM Sans, sans-serif",
                        color: "rgba(0, 0, 0, 0.85)",
                      lineHeight: 2,
                      fontSize: '14px',
                    }}>
                  {text}
                </div>
              <Divider />
              <Row justify={'end'}>
                  <Button size={'large'} style={{width: '100%'}} type="primary" onClick={onAgree}>I Agree</Button>
              </Row>
            </div>
      </div>
  );
};

export default Disclaimer;
